import React from "react";
import { useParams } from 'react-router-dom';

function DocView() {
    const { s3Key } = useParams();
    const { id } = useParams();

    React.useEffect(() => {
        const decodedUrl = decodeURIComponent(s3Key);
        const currentUrl = window.location.href;

        const urlParts = currentUrl.split("/docview/");

        const dfdfd = urlParts[1]

        const awsS3PresignedUrl = `https://stage-ink-agent.s3.amazonaws.com/uploads/${dfdfd}`;
        if (awsS3PresignedUrl.endsWith('.')) {
            const urlWithoutDot = awsS3PresignedUrl.slice(0, -1);
            window.location.href = urlWithoutDot;
        } else {
            window.location.href = awsS3PresignedUrl;
        }

        if (s3Key) {
            // Construct the AWS S3 presigned URL

            // Redirect the user to the presigned URL
            window.location.href = awsS3PresignedUrl;
        }
    }, [s3Key]);

    return (
        <div>
            <h1>Redirecting to the document...</h1>
        </div>
    );
}

export default DocView;
